import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router";
//
import Box from "@mui/material/Box";
import { styled } from "@material-ui/styles";
import Typography from "@mui/material/Typography";
//
import useLocaleRoute from "../../../../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../../../../hooks/useModulePublic";
import { StoreContext } from "../../../../../../../../store/StoreProvider";
import Selection from "../../../../../../../../common/components/input/Selection";
//
import Act from "../../../../../../../../store/actions";
import { MODULE_ID } from "../../../../../../../../config/CONSTANTS";
import urls from "../../../../../../../../api/project/ApiUrls";
// eslint-disable-next-line import/named
import { fileMineTypeOpts } from "../option";

const selectOpts = fileMineTypeOpts;

const FileMineType = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale } = user;
  const { fileMineType } = sna.export || {};
  // local state
  const [localOptions, setLocalOptions] = useState(selectOpts);
  const [inputVal, setInputVal] = useState(fileMineType || "");

  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  useEffect(() => {
    if (fileMineType) {
      setInputVal(fileMineType);
    }
  }, [fileMineType]);

  const handleInputChange = (e) => {
    const { value } = e.target;
    setInputVal(value);
    dispatch({
      type: Act.SNA_EXPORT_FILE_MINE_TYPE,
      payload: value,
    });
  };

  return (
    <Box>
      <Typography variant="body2">
        <FormattedMessage
          id="sna.topPanel.export.popup.export.minetype"
          defaultMessage="請選擇匯出格式"
        />
      </Typography>
      <Selection
        options={localOptions}
        size="normal"
        darkMode={false}
        fullWidth
        inputProps={{
          value: inputVal,
          onChange: handleInputChange,
          // defaultValue: "",
        }}
        MenuProps={{}}
      />
    </Box>
  );
};

export default FileMineType;
